import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../../environments/environment';
import {AuthService} from "../../../../auth/api/service/auth.service";
import {IWithPermissionModel} from "../entity/iWithPermission.model";

@Injectable({
    providedIn: 'root'
})
export class PermissionService {

    permissionValuesLoading = false;
    private permissionValues: string[];
    private userId: number;
    private accountId: number;

    constructor(private httpClient: HttpClient,
                private authService: AuthService) {
    }

    entityHasPermission(entity:IWithPermissionModel, permissionValue: string): boolean {
        if (!entity) {
            return false;
        }
        return entity.permissions.permissions.includes(permissionValue);
    }

    hasPermission(permissionValue: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if (this.authService.userSnapshot?.summary?.superUser || this.authService.userSnapshot?.summary?.admin) {
                resolve(true);
            } else {
                if (this.mustReloadPermissions()) {
                   this.loadPermissions()
                       .then(() => resolve(this.isPermissionIncluded(permissionValue)))
                       .catch(() => resolve(false));
                } else {
                    resolve(this.isPermissionIncluded(permissionValue));
                }
            }
        });
    }

    hasAtLeastOnePermission(permissionValues: string[]): Promise<boolean> {
        // console.log(['hasAtLeastOnePermission', permissionValues]);
        return new Promise<boolean>((resolve, reject) => {
            if (this.authService.userSnapshot?.summary?.superUser || this.authService.userSnapshot?.summary?.admin) {
                resolve(true);
            } else {
                if (this.mustReloadPermissions()) {
                    this.loadPermissions()
                        .then(() => resolve(this.isAtLeastOnePermissionIncluded(permissionValues)))
                        .catch(() => resolve(false));
                } else {
                    resolve(this.isAtLeastOnePermissionIncluded(permissionValues));
                }
            }
        });
    }

    private loadPermissions(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.permissionValuesLoading = true;
            this.httpClient.get<string[]>(environment.webserviceUrl + '/v1/user/get-current-user-permission-values').toPromise()
                .then(permissionValues => {
                    this.permissionValues = permissionValues;
                    this.userId = this.authService?.userSnapshot?.summary?.id;
                    this.accountId = this.authService?.accountSnapshot?.summary?.id;
                    console.log(['Fetched user permissions', this.permissionValues]);
                    resolve();
                })
                .catch((e) => console.error(e))
                .finally(() => this.permissionValuesLoading = false);
        });
    }

    public clearPermissions() {
        this.permissionValues = undefined;
    }

    private isPermissionIncluded(permission: string): boolean {
        const hasPermission = this.permissionValues.indexOf(permission) !== -1 || this.permissionValues.indexOf('ALL_ACCESS_RIGHTS') !== -1;
        return hasPermission;
    }

    private isAtLeastOnePermissionIncluded(permissions: string[]): boolean {
        for (const item of permissions) {
            if (this.isPermissionIncluded(item)) {
                return true;
            }
        }
        return false;
    }

    mustReloadPermissions() {
        return this.permissionValues === undefined
        || this.authService.accountSnapshot?.summary?.id !== this.accountId
        || this.authService.userSnapshot?.summary?.id !== this.userId;
    }
}
